import React, { useMemo } from 'react';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import WarningIcon from 'src/components/Icon/Warning';
import css from './css.module.less';
//import { checkResponsiveImageCarousel } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { get } from 'lodash';
import ImageAndPosterEditModalBody from 'src/components/Modules-revamp/ImageAndPoster';
import { Field } from 'src/components/RcForm';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { images } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { EnumModuleType } from 'src/types/common/module';
const Images = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    onChange,
    id,
    draggableId,
    moduleType,
    breakpoint,
    modalOp,
    hasModal,
    modalFunc,
    onModalConfirm,
    onSort,
    onAdd,
    onDelete,
    allValidator,
    animationOptions,
    buttons,
    disabled,
    hoverEffectOptions,
    validators,
    translateEnabled,
  } = props;
  const isPoster = moduleType === EnumModuleType.ResponsivePoster;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const isHideAdd =
    moduleType === EnumModuleType.ResponsivePoster ||
    disabled ||
    translateEnabled;
  const titleGenerator = () => {
    if (moduleType === EnumModuleType.ResponsiveImageCarousel) {
      return getI18n('salesChannelContent.index.carouselImageSetting');
    }
    if (isPoster) {
      return getI18n('salesChannelContent.index.posterSetting');
    }
  };
  const addTextGenerator = () => {
    if (moduleType === EnumModuleType.ResponsiveImageCarousel) {
      return `+ ${getI18n('general.addImage')}`;
    }
    if (isPoster) {
      return `+ ${getI18n('salesChannelContent.index.addPoster')}`;
    }
  };
  const checkIndividualImage = (data) => {
    const allValidatorsList = [
      EnumModuleType.ResponsiveImageCarousel,
      EnumModuleType.ResponsivePoster,
    ];
    if (allValidatorsList.includes(moduleType)) {
      if (allValidator) {
        const res = allValidator(data, { breakpoint });
        const hasError = get(res, 'hasError');
        return hasError;
      }
    }
    return false;
  };

  const handleOnChildGenerate = (data, index) => {
    const hasError = checkIndividualImage(data);
    // console.log('data1', data);
    const { name } = data;

    return (
      <TextAndEditIcon
        {...(isPoster
          ? {
              containerClassName: css.editIcon,
            }
          : {})}
        disabled={disabled}
        additional={
          hasError ? (
            <div className={css.errorIconContainer}>
              <WarningIcon />
            </div>
          ) : null
        }
        name={name}
        onClick={() => {
          if (hasModal) {
            setModalTitle(titleGenerator());
            setModalContent(
              <ImageAndPosterEditModalBody
                validators={validators}
                data={data}
                breakpoint={breakpoint}
                animationOptions={animationOptions}
                hoverEffectOptions={hoverEffectOptions}
                buttons={buttons}
                modalRenderer={modalFunc}
                disabled={translateEnabled}
                onConfirm={(v) => {
                  setShowModal(false);
                  onModalConfirm({
                    ...(data || {}),
                    ...v,
                  });
                }}
                onCancel={() => {
                  setShowModal(false);
                }}
              />,
            );
            setShowModal(true);
          }
          // if (onEdit) onEdit(draggableId, data, hasError);
        }}
      />
    );
  };
  const handleOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onSort(value, onChange, oldIndex, newIndex);
  };
  const handleOnDelete = (index) => {
    onDelete(value, onChange, index);
  };
  const handleOnAdd = () => {
    if (moduleType === EnumModuleType.ResponsiveImageCarousel) {
      onAdd(value, onChange);
    }
    if (moduleType === EnumModuleType.ResponsivePoster) {
      onAdd(value, onChange);
    }
  };

  const _value = useMemo(() => {
    return Array.isArray(value)
      ? value.map((v) => ({ ...v, hideDelete: disabled }))
      : [];
  }, [value, disabled]);

  return (
    <DragNDropColumns
      id={id}
      disabled={disabled || translateEnabled}
      {...(isPoster ? {} : { disableAddText: isHideAdd })}
      //disableAddText={isHideAdd}
      hideAdd={isHideAdd}
      hideTitle
      childGenerate={handleOnChildGenerate}
      data={_value}
      droppableId={`salesChannelContentListResponsiveImageCarousel${draggableId}`}
      onSort={handleOnSort}
      onAdd={handleOnAdd}
      addText={addTextGenerator()}
      onDelete={isPoster ? null : handleOnDelete} //isWide ? handleOnDelete : null}
    />
  );
};

const ImagesWithField = (props) => {
  const {
    draggableId,
    moduleType,
    breakpoint,
    modalOp,
    hasModal,
    modalFunc,
    ..._props
  } = props;
  return (
    <Field name={images}>
      {(props, meta) => (
        <Images
          id={`${get(meta, 'name').join('_')}_${draggableId}`}
          draggableId={draggableId}
          moduleType={moduleType}
          breakpoint={breakpoint}
          hasModal={hasModal}
          modalFunc={modalFunc}
          modalOp={modalOp}
          {..._props}
          {...props}
          {...meta}
        />
      )}
    </Field>
  );
};
export default ModalHoc(ImagesWithField, {
  width: 1180,
  responsiveHeight: true,
});
